import { createFileRoute, redirect } from '@tanstack/react-router';

/** Ancien nom des onglets : les adresses `/reglages?onglet=…` déjà diffusées continuent de marcher. */
const ANCIENS_ONGLETS = {
  compte: '/settings/account',
  cabinet: '/settings/practice',
  envoi: '/settings/sending',
  signatures: '/settings/signatures',
} as const;

type AncienOnglet = keyof typeof ANCIENS_ONGLETS;

export const Route = createFileRoute('/_app/reglages')({
  validateSearch: (search: Record<string, unknown>): { onglet?: AncienOnglet } => {
    const onglet = search.onglet;
    return typeof onglet === 'string' && onglet in ANCIENS_ONGLETS
      ? { onglet: onglet as AncienOnglet }
      : {};
  },
  beforeLoad: ({ search }) => {
    throw redirect({ to: ANCIENS_ONGLETS[search.onglet ?? 'compte'], replace: true });
  },
});
